export interface Project {
  title: string;
  description: string;
  attribution: 'Scaled Tech delivery' | 'Earlier experience';
  link?: string; // assuming the link is optional
  tags: string[];
}

const projects: Project[] = [
  {
    attribution: 'Scaled Tech delivery',
    title: 'The Garden Marquee',
    tags: ['Next.js', 'PostgreSQL', 'CMS', 'Inquiry Workflows'],
    description:
      'Built a venue website with authenticated tools for staff to edit pages, posts, galleries, and FAQs. Its inquiry flow checks date availability and brings requests into an administrative workflow.',
  },
  {
    attribution: 'Earlier experience',
    title: 'Art For Africa',
    tags: ['xHTML', 'CSS', 'eCommerce', 'iCAL'],
    description:
      'An archival charitable arts website developed with artist M. W. in memory of Melanie Woodward.',
  },
  {
    attribution: 'Earlier experience',
    title: 'Canadian Pork Council (CPC/CCP)',
    link: 'https://www.cpc-ccp.com/',
    tags: ['CMS', 'PHP', 'MySql', 'JavaScript', 'CSS', 'xHTML', 'AJAX', 'iCAL'],
    description:
      'Built a shared content system for news and events, with PDF text conversion, forum integration, and French-language publishing.',
  },
  {
    attribution: 'Earlier experience',
    title: 'Canadian Hog Producers',
    tags: ['CMS', 'PHP', 'MySql', 'JavaScript', 'CSS', 'xHTML', 'AJAX', 'iCAL'],
    description:
      'Built a private portal for documents, calendars, and content in English and French.',
  },
  {
    attribution: 'Earlier experience',
    title: 'Swinehealth.ca',
    tags: ['CMS', 'PHP', 'MySql', 'JavaScript', 'CSS', 'xHTML', 'AJAX'],
    description:
      'Supported related sites from a shared publishing system while allowing audience-specific content and French-language pages.',
  },
  {
    attribution: 'Earlier experience',
    title: 'Paradisal Imagery Inc.',
    tags: ['PHP', 'MySql', 'JavaScript', 'eCommerce'],
    description:
      'Updated a photography website with account protections, online sales, and image watermarking.',
  },
  {
    attribution: 'Earlier experience',
    title: 'TeleClass International',
    tags: [
      'SEO',
      'XML',
      'PHP',
      'PERL',
      'MySql',
      'JavaScript',
      'Flash',
      'RSS',
      'eCommerce',
      'CRM',
      'AJAX',
    ],
    description:
      'Improved and rewrote modules across a set of teleconference platforms serving different audiences.',
  },
  {
    attribution: 'Earlier experience',
    title: 'Journal Anywhere',
    tags: ['PERL', 'MySql', 'Paypal IPN'],
    description: 'Built a PayPal payment integration in collaboration with StellarWebSolutions.',
  },
  {
    attribution: 'Earlier experience',
    title: 'Canada Events',
    tags: ['XML', 'ASP', 'PERL', 'MySql', 'JavaScript'],
    description:
      'Maintained the site and connected XML feeds that supplied cinema listings during the engagement.',
  },
  {
    attribution: 'Earlier experience',
    title: 'Bangkok Restaurant',
    tags: ['MySql', 'PHP', 'JavaScript'],
    description: 'Built a menu editor that imported CSV data from multiple restaurant locations.',
  },
  {
    attribution: 'Earlier experience',
    title: 'DTC Forevermark',
    tags: ['PHP', 'MySql'],
    description: 'Built a tool to track and manage bounced email for the project team.',
  },
  {
    attribution: 'Earlier experience',
    title: 'SpyderCo',
    tags: ['PHP', 'YaBB'],
    description:
      'Extended an open-source discussion board with multi-image posts and additional member features.',
  },
  {
    attribution: 'Earlier experience',
    title: 'TellaFriend',
    tags: ['Perl', 'MySql', 'JavaScript'],
    description: 'Moved an email marketing tool from flat-file storage to a MySQL database.',
  },
  {
    attribution: 'Earlier experience',
    title: 'Travel Masters',
    link: 'https://travelmasters.ca/',
    tags: ['PHP', 'XML', 'ASP.NET', 'SQL Server'],
    description:
      'Built travel pages from external XML feeds and tools that let agents search the updated data.',
  },
  {
    attribution: 'Earlier experience',
    title: 'Sportlinker.com',
    tags: ['Perl', 'MySql'],
    description:
      'Maintained and expanded a sports management platform with team tools and dedicated subdomains.',
  },
  {
    attribution: 'Earlier experience',
    title: 'Nortel Networks',
    tags: ['CRM', 'C++', 'Perl', 'XML', 'Oracle', 'JavaScript'],
    description: 'Developed web tools for equipment lifecycle tracking and upgrade notifications.',
  },
  {
    attribution: 'Earlier experience',
    title: 'Collin Griffiths and Associates Ltd. (Grifftax)',
    tags: ['Visual C++', 'C++', 'HTML', 'JavaScript'],
    description:
      'Built software registration and e-commerce components and contributed to the core of a commercial tax application.',
  },
];

export default projects;
